import { get } from './utils';

export const getProvidersOfCompanyApi = (id, data) =>
  get(`/admin/companies/${id}/providers`, data);

export const getOwnedCompaniesOfAllUserRolesApi = (orderBy) =>
  get(`/admin/companies`, orderBy);
